import React from 'react';
import noop from 'mn-utils/noop';
import delay from 'mn-utils/delay';
import withState from '../../../../../../../utils/withState';
import {backLocation, pushLocation} from '../../../../../../../router';
import WrapperWithLoading from '../../../../../../dumb/WrapperWithLoading/B';
import Caption from '../../../../../../dumb/Caption/C';
import ButtonBack from '../../../../../../dumb/Button/BackB';

import normalizeAuth from './utils/normalizeAuth';
import appGet from './utils/appGet';

import NotificationForm from './NotificationForm';
import {LINK_DEVELOPER_OPTIONS} from "../../../../../../../constants/links";
import {MerchantPageHeader} from "../../../../../../helpers/Display";

const AUTH_TYPE_BASIC = 'Basic';

module.exports = withState((setState, self, onMount) => {
  self.state = {
    loading: true,
  };
  let _appId;
  let _cancel = noop;

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  function setParentErrorState(error) {
    setState({
      fetchError: error
    })
  }

  function updateBase() {
    _cancel = appGet({
      id: _appId,
    }).finally((error, response) => {
      if (error) {
        setState({
          loading: false,
          fetchError: error
        });
      }

      response = response || {};
      const notificationSettings = response.notification_settings || {};
      const proxyAuth = normalizeAuth(notificationSettings.proxy_auth || {});


      const state = {
        auth: normalizeAuth(notificationSettings.auth || {}),
        proxyAuth: {
          ...proxyAuth,
          type: AUTH_TYPE_BASIC,
        },
        defaultCallbackUrlEnabled: notificationSettings.callback_enabled || false,
        defaultCallbackUrl: notificationSettings.callback_url || '',
        headers: notificationSettings.headers || [],
        awaitingConfirmationEnabled: !notificationSettings.awaiting_confirmation_disabled,
        expiredEnabled: !notificationSettings.expired_disabled,
      };
      setState({
        data: {
          ...response,
          ...state
        },
        prev: state,
        loading: false,
      });
    }).cancel;
  }
  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      updateBase();
    });
  }

  return (state, props) => {
    const appId = props.id;
    _appId === appId || update(_appId = appId);

    const { data, prev, fetchError } = state;

    return (
      <div className={'wmin270 ' + (props.className || '')}>
        <MerchantPageHeader
          title="Notification settings"
          backFN={props.onBack || noop}
        />
        {/*<div className="layoutRow fhaS fvaC">*/}
        {/*  <ButtonBack*/}
        {/*    className="m-10 mr10"*/}
        {/*    onClick={props.onBack || noop}*/}
        {/*  />*/}
        {/*  <Caption>Notification settings</Caption>*/}
        {/*</div>*/}
        <WrapperWithLoading
          className="mt35 wmax900 w@m"
          loading={state.loading}
        >
          {fetchError
            ? (
              <span>
                {fetchError.message}
              </span>
            ) : (
              !!data && (
                <NotificationForm
                  appId={appId}
                  data={data}
                  prev={prev}
                  setParentErrorState={setParentErrorState}
                />
              )
            )
          }
        </WrapperWithLoading>
      </div>
    );
  };
});
